import React, { FC } from 'react'
import ImmunizationList from './ImmunizationList'
import ImmunizationDetail from './ImmunizationDetail'
import { ImmunizationBundle } from '../../../../types/FHIRTypes/Bundle'

type ImmunizationsProps = {
  immunizationData: ImmunizationBundle;
  immunizationDetailId: string | undefined;
  page: string | undefined;
  isFetching: boolean;
  handleChangePage: (page: number) => void
  totalPages: number;
  currentPage: number;
}

const Immunizations: FC<ImmunizationsProps> = ({ immunizationData, immunizationDetailId, page, isFetching, handleChangePage, totalPages, currentPage }) => {

  return (
    <div>
      {
        immunizationDetailId && page === 'Immunization' ? (
          <ImmunizationDetail
            detailId={immunizationDetailId}
          />
        ) :
          <ImmunizationList
            immunizationData={immunizationData}
            isFetching={isFetching}
            handleChangePage={handleChangePage}
            totalPages={totalPages}
            currentPage={currentPage}
          />
      }
    </div>
  )
}
export default Immunizations